import MaterialFormControl from '@material-ui/core/FormControl';
import MaterialInputLabel from '@material-ui/core/InputLabel';
import MaterialMenuItem from '@material-ui/core/MenuItem';
import MaterialSelect from '@material-ui/core/Select';

import styles from './styles';

const placeholderValue = '';

function Select({
  children,
  className,
  classes,
  error,
  label,
  onChange,
  placeholder,
  renderValue,
  required,
  value,
  ...props
}) {
  return (
    <MaterialFormControl
      className={className}
      classes={{
        root: classes.formLabelRoot,
      }}
      error={error}
      fullWidth
      required={required}
      {...props}>
      {label && <MaterialInputLabel shrink={false}>{label}</MaterialInputLabel>}

      <MaterialSelect
        className={classes.inputRoot}
        displayEmpty={!!placeholder}
        onChange={onChange}
        renderValue={renderValue}
        value={value || placeholderValue}>
        {placeholder && (
          <MaterialMenuItem disabled value={placeholderValue}>
            {placeholder}
          </MaterialMenuItem>
        )}

        {children}
      </MaterialSelect>
    </MaterialFormControl>
  );
}

Select.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  error: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  renderValue: PropTypes.func,
  required: PropTypes.bool,
  value: PropTypes.string,
};

Select.MenuItem = MaterialMenuItem;

export default withStyles(styles)(Select);
